import {
    AnalyticsEvent,
    GTMEventData,
    EVENT_UAEVENT,
} from "@hermes/fragments/analytics";

import { EVENT_PRODUCT_GRID, FILTERS } from "../constants/grid.constant";

export interface GridFilterDisplayOnlyChangedEventPayload {
    eventType: "Display_only_no" | "Display_only_yes";
}

export class GridFilterDisplayOnlyChangedEvent
    implements AnalyticsEvent<GTMEventData>
{
    public name: string = EVENT_UAEVENT;
    public eventData: GridFilterDisplayOnlyChangedEventPayload;

    constructor(data: GridFilterDisplayOnlyChangedEventPayload) {
        this.eventData = data;
    }

    public formatForGTM(): GTMEventData {
        return {
            event: this.name,
            eventcategory: EVENT_PRODUCT_GRID,
            eventaction: FILTERS,
            eventlabel: this.eventData.eventType,
        };
    }
}
